export default "__VITE_ASSET__DqOLaB1l__"